import { render, staticRenderFns } from "./EN_TermsAndConditions.vue?vue&type=template&id=4bf04672&scoped=true&"
import script from "./EN_TermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./EN_TermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./EN_TermsAndConditions.vue?vue&type=style&index=0&id=4bf04672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf04672",
  null
  
)

export default component.exports